import { render, staticRenderFns } from "./goal-categories-section.vue?vue&type=template&id=1e429602&scoped=true&"
import script from "./goal-categories-section.vue?vue&type=script&lang=js&"
export * from "./goal-categories-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e429602",
  null
  
)

export default component.exports